import { handleActions } from "redux-actions";
import { CART_NOTIFICATIONS } from "constants/action-types";

export interface INotification {
    id: string;
    type: string;
    message: string;
    dismiss?: boolean;
}

export interface ICartNotificationsState {
    active: INotification[];
    dismissed: string[];
}

export const initialState: ICartNotificationsState = {
    active: [],
    dismissed: [],
};

export const cartNotificationsReducer = handleActions<ICartNotificationsState, any>(
    {
        [CART_NOTIFICATIONS.UPDATE]: (state, { payload }: { payload: ICartNotificationsState }) => ({
            ...state,
            ...payload,
        }),
    } as any,
    initialState
);
